import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable()
export class AbaqusApiKeyInterceptor implements HttpInterceptor {

    constructor() {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (request.url.includes(environment.abaqusApiUrl)) {
            const newRequest = request.clone(
                {headers: request.headers.set("X-API-KEY", environment.abaqusApiKey)})
            return next.handle(newRequest);
        } else {
            return next.handle(request);
        }
    }

}
